
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/variety-act-landing",
      function () {
        return require("private-next-pages/variety-act-landing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/variety-act-landing"])
      });
    }
  